import { Component, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../../app.service';
import { GETInventoryService } from '../../services/inventory.service';
import { DissAssemblyInspectionVM, ProgressReportingInspectionVM } from './add-fecr-recommendation';
import { RemoveImplementModalComponent } from '../../remove-implement-modal/remove-implement-modal.component';
import { ModalObsRecommendation } from './add-fecr-recommendation'
import { FrontEndComponetService } from '../front-end-componet.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EditPhotoDigitalComponent } from '../../digital-form-fill/component/edit-photo-digital/edit-photo-digital.component';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-add-fecr-recommendation',
  templateUrl: './add-fecr-recommendation.component.html',
  styleUrls: ['./add-fecr-recommendation.component.scss'],
  //   providers: [
  //     {
  //         provide: DateAdapter, useClass: OrdinalDateAdapter
  //     },
  //     {
  //         provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
  //     }
  // ]
})
export class AddFecrRecommendationComponent {
  ApprovalCommentHistory:string;
  ApprovalComment: string
  AppResponse: number = 0;
  AppRequired: number = 2;
  oldAppRequired:number;
  oldAppResponse:number;
  ObsCompletePercentage: number = 0;
  obsStatus: string;
  obsRepairCostComment: string;
  obsRepairTotal: number = 0;
  obsMiscCost: number = 0;
  obsPartsCost: number = 0;
  obsLabourCost: number = 0;
  obsHours: number = 0;
  obsRecommendation: string
  obsInspectionComment: string;
  showRequiredError: boolean = false;
  obsId: number;
  ImplementId: number;
  SchematicImage: string;
  ObsPointX: number;
  ObsPointY: number;
  ObsName: string;
  CompName: string;
  CompTypeName: string;
  obsRepairPartsList:string;
  selectedInspectionType: number;
  ProgressReportingInfo: ProgressReportingInspectionVM;

  DissAssemblyInspectionInfo: DissAssemblyInspectionVM;
  constructor(
    private _fecrService: FrontEndComponetService,
    private _appService: AppService, public dialogRef: MatDialogRef<RemoveImplementModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _sanitizer: DomSanitizer,
    public _inventoryService: GETInventoryService, public addRepairerWorkshopModal: MatDialog,private _editPhotoDialog: MatDialog,
    public toastr: NotificationsService, vcr: ViewContainerRef) {
    
  }
  ngOnInit() {
    this.obsId = this.data.obsId;
    this.ImplementId = this.data.ImplementId
    this.loadExsistingData();
    this.LoadFECRObsPointInspectionHistroy();
  }

  OnChangeLabourCost(val) {

    this.obsRepairTotal = Number(val) + this.obsPartsCost + this.obsMiscCost
  }
  OnChangePartsCost(val) {

    this.obsRepairTotal = Number(val) + this.obsLabourCost + this.obsMiscCost
  }
  OnChangeMiscCost(val) {

    this.obsRepairTotal = Number(val) + this.obsPartsCost + this.obsLabourCost
  }

  loadExsistingData() {

    this._fecrService.GETExistingRecommendationData(this.obsId).subscribe(r => {
      console.log("GETExistingRecommendationData", r)
      if (r) {
        this.SchematicImage = r.SchematicImage
        this.ObsPointX = r.ObsPointX
        this.ObsPointY = r.ObsPointY
        this.ObsName = r.ObsName
        //this.ApprovalComment = r.approvalComment
        this.ApprovalCommentHistory = r.approvalComment
        this.AppRequired = r.approvalRequired
        this.AppResponse = r.approvalResponse
        this.oldAppRequired = r.approvalRequired
        this.oldAppResponse = r.approvalResponse
        //ObsCompletePercentage: number = 0;
        this.obsStatus = r.status
        this.ObsCompletePercentage = r.completePercentage
        this.obsRepairCostComment = r.repairCostComment
        this.obsRepairTotal = r.total
        this.obsMiscCost = r.misc_cost
        this.obsPartsCost = r.parts_cost
        this.obsLabourCost = r.labour_cost
        this.obsHours = r.hours
        this.obsRecommendation = r.RequiredAction
        this.obsInspectionComment = r.InspectionComment
        this.CompTypeName = r.CompTypeName
        this.CompName = r.CompName
        this.obsRepairPartsList = r.obsRepairPartsList
      }


    })

  }

  getPosition(posX: any, posY: any) {
    console.log("posY__",posY)
    var iPX = (parseFloat(posX) / 640.0) * 290;
    var iPY = (parseFloat(posY) / 520.0) * 244;
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

//LoadObsCRCHistroy
arrInspectionTypes: any[];
LoadFECRObsPointInspectionHistroy(){
  this._fecrService.GETObservationPointDetailsUsingType(this.ImplementId, this.obsId).subscribe(r => {
    console.log("GETObservationPointDetailsUsingType", r)
    if (r) {
      this.arrInspectionTypes = r.ObsDetails
      console.log("this.arrInspectionTypes", this.arrInspectionTypes)
    }
  })
}


  measurement: number;
  ReadingNumber: number;
  eval: number;
  ChangeInspectionType() {

    if (this.selectedInspectionType == 4) {
      //Progress Reporting
      this._fecrService.GETDisassemblyInspectionData(this.obsId, this.ImplementId).subscribe(res => {
        this.DissAssemblyInspectionInfo = res;
        console.log("DissAssemblyInspectionInfo__", this.DissAssemblyInspectionInfo)
        if (this.DissAssemblyInspectionInfo.obsTypeID != 3 && this.DissAssemblyInspectionInfo.obsTypeID != 4) {
          this.ReadingNumber = this.DissAssemblyInspectionInfo.ObsMeasurements[0].ReadingNumber;
          this.measurement = this.DissAssemblyInspectionInfo.ObsMeasurements[0].Measurement==-99?null:this.DissAssemblyInspectionInfo.ObsMeasurements[0].Measurement;
          this.UoM = this.DissAssemblyInspectionInfo.ObsMeasurements[0].UOM;
        } else {
          this.ReadingNumber = this.DissAssemblyInspectionInfo.ObsMeasurements[0].ReadingNumber;
          this.eval = this.DissAssemblyInspectionInfo.ObsMeasurements[0].Measurement;
          this.UoM = this.DissAssemblyInspectionInfo.ObsMeasurements[0].UOM;

        }
      })
    } else if (this.selectedInspectionType == 6) {
      //Progress Reporting
      this._fecrService.GETProgressReportingInspectionData(this.obsId, this.ImplementId).subscribe(res => {
        this.ProgressReportingInfo = res;
        console.log("ProgressReportingInfo__", this.ProgressReportingInfo)
      })



    }
  }

  UpdateMeasurement(event: any) {
    let measurement_ = event.target.value;
    this.DissAssemblyInspectionInfo.ObsMeasurements.map(x => {
      if (x.ReadingNumber == this.ReadingNumber) {
        x.Measurement = measurement_;
      }
    })
  }

  ChangeReadingNum(event: any) {
    this.measurement = null;
    console.log("ReadingNum_", event)
    let val = event.target.value;
    this.ReadingNumber = val;

    //this.measurement = null;

   
    if (this.DissAssemblyInspectionInfo.obsTypeID != 3 && this.DissAssemblyInspectionInfo.obsTypeID != 4) {
      this.DissAssemblyInspectionInfo.ObsMeasurements.map(x => {
        if (x.ReadingNumber == this.ReadingNumber) {
         
          if(x.Measurement==-99){
            this.measurement=null;
          }else{
            this.measurement = x.Measurement;
          }
          console.log("ReadingNum_",this.ReadingNumber,"measuremtn_", this.measurement )
        }
      })
    }

  }
  saveChanges(): void {


    if (!this.obsRecommendation) {
      this.showRequiredError = true;
      return;
    } else {
      this.showRequiredError = false;
    }

    
    let params: ModalObsRecommendation = {
      InspectionComment: this.obsInspectionComment,
      RequiredAction: this.obsRecommendation,
      hours: this.obsHours,
      labour_cost: this.obsLabourCost,
      parts_cost: this.obsPartsCost,
      misc_cost: this.obsMiscCost,
      total: this.obsRepairTotal,
      repairCostComment: this.obsRepairCostComment,
      status: this.obsStatus,
      completePercentage: this.ObsCompletePercentage,
      approvalRequired: this.AppRequired,
      approvalResponse: this.AppResponse,
      approvalComment: this.ApprovalComment,
      ObsId: this.obsId,
      ImplementId: this.ImplementId,
      RequestChange:this.oldAppRequired!=this.AppRequired?true:false,
      ResponseChange:this.oldAppResponse!=this.AppResponse?true:false,
      obsRepairPartsList:this.obsRepairPartsList
    }

    console.log("params", params)

    this._fecrService.UpdateObsRecommendation(params).subscribe(r => {
      console.log("UpdateObsRecommendation", r)
      if (r.m_Item1 == 1) {
        this.toastr.success('Saved', r.m_Item2);
        this.dialogRef.close(true);
      } else {
        this.toastr.error('Failed', r.m_Item2);

      }

    })

  }

  SelectEvaluation(event: any) {
    this.eval = event.target.value;
    this.DissAssemblyInspectionInfo.ObsMeasurements.map(x => {
      x.Measurement = this.eval;
    })
  }
  showError:boolean=false;
  saveChangesInspection() {
    this.showError=false;
    if (this.selectedInspectionType == 6) {

      if (this.AppRequired == 1 && this.AppResponse == 2) {
        this.showError=true;
      } else {
        console.log("update__", this.ProgressReportingInfo)
        this.ProgressReportingInfo.InspectiontypeId = this.selectedInspectionType;
        this.ProgressReportingInfo.ImplementId = this.ImplementId;
        this.ProgressReportingInfo.obsPointId = this.obsId;
        this._fecrService.AddNewProgressReportingInspection(this.ProgressReportingInfo).subscribe(r => {
          if (r.m_Item1 > 0) {
            this.toastr.success('Saved', r.m_Item2)
            this.dialogRef.close(true);
          } else {
            this.toastr.error('Failed', r.m_Item2);
          }
        })
      }
    }
    else {

      this.DissAssemblyInspectionInfo.InspectiontypeId = this.selectedInspectionType;
      this.DissAssemblyInspectionInfo.ImplementId = this.ImplementId;
      this.DissAssemblyInspectionInfo.obsPointId = this.obsId;

      this._fecrService.AddNewDisAssemblyInspection(this.DissAssemblyInspectionInfo).subscribe(r => {
        if (r.m_Item1 > 0) {
          this.toastr.success('Saved', r.m_Item2)
          this.dialogRef.close(true);
        } else {
          this.toastr.error('Failed', r.m_Item2);
        }
      })

    }

  }
  Imagelist: string[];
  image: string;

  onSelectPhoto(event) {
    if (event.target.files && event.target.files[0]) {
      this.Imagelist = [];
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var imageUrl = (event.target["result"]).split(',');
        this.Imagelist.push(imageUrl[1]);
        this.image = imageUrl[1];

        if (this.selectedInspectionType == 6) {
          if (this.ProgressReportingInfo.ImageList == null) {
            this.ProgressReportingInfo.ImageList = this.Imagelist;
          } else {
            this.ProgressReportingInfo.ImageList.push(this.image)
          }
        }
        if (this.selectedInspectionType == 4) {
          if (this.DissAssemblyInspectionInfo.ImageList == null) {
            this.DissAssemblyInspectionInfo.ImageList = this.Imagelist;
          } else {
            this.DissAssemblyInspectionInfo.ImageList.push(this.image)
          }
        }

      }
    }
  }

  deleteimageProgress(image: string) {
    this.ProgressReportingInfo.ImageList = this.ProgressReportingInfo.ImageList.filter(x => x != image);
  }

  deleteimageDisAssembly(image: string) {
    this.DissAssemblyInspectionInfo.ImageList = this.DissAssemblyInspectionInfo.ImageList.filter(x => x != image);
 

  }
  openUploadEditImageDisAssemble(image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
      data: { photoWithExt: 'data:image/png;base64,' + image }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        console.log("updated", res)
        let arr_ = [...this.DissAssemblyInspectionInfo.ImageList];
        arr_ = arr_.filter(x => x != image);
        let editImg = res.photo;
        arr_.push(editImg);
        this.DissAssemblyInspectionInfo.ImageList = arr_;

      }
    });
  }

  openUploadEditImageProgress(image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
      data: { photoWithExt: 'data:image/png;base64,' + image }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        console.log("updated", res)
        let arr_ = [... this.ProgressReportingInfo.ImageList];
        arr_ = arr_.filter(x => x != image);
        let editImg = res.photo;
        arr_.push(editImg);
        this.ProgressReportingInfo.ImageList = arr_;

      }
    });
  }

 
  UoM: number;
  ChangeUnitType(event: any) {
    console.log("UOM___", event.target.value)
    this.UoM = event.target.value;
    this.DissAssemblyInspectionInfo.ObsMeasurements.map(x => {
      if (x.ReadingNumber == this.ReadingNumber) {
        x.UOM = this.UoM;
      }
    })
  }

}


